import React from "react";
import ComingSoon from "../../../components/ComingSoon";

export default function Management() {
  return <ComingSoon title="Complete HR Function Management" />;
}
